import React, { useCallback } from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";
import { useGA4CommonParameters, useSendImpressionEvents } from "scmp-sdk/components/rosetta/hooks";
import { SubscriptionButton } from "scmp-sdk/components/rosetta/subscription-button/styles";
import type { GA4Event } from "scmp-sdk/lib/google-analytics/ga4-types";

import { PageType } from "shared/lib/page-type";

type Props = {
  className?: string;
};
export const UpgradeButton: React.FunctionComponent<Props> = ({ className }) => {
  const { config, currentPageType, handleTrackGA4 } = useSdkContext();
  const { computeGA4CommonParameters } = useGA4CommonParameters();

  const { captureTrackImpressionEventTargetElement } = useSendImpressionEvents({
    ga4Event: useCallback<() => GA4Event>(
      () => ({
        action: "imp",
        category: "subs",
        customized_parameters: {
          ...computeGA4CommonParameters(),
          call_to_action: "upgrade",
          trigger_point:
            currentPageType === PageType.Article ? "article masthead upgrade button" : "masthead",
        },
        subcategory: "entry_point",
      }),
      [computeGA4CommonParameters, currentPageType],
    ),
  });
  return (
    <SubscriptionButton
      className={className}
      onClick={() => {
        handleTrackGA4({
          action: "click",
          category: "subs",
          customized_parameters: {
            ...computeGA4CommonParameters(),
            call_to_action: "upgrade",
            trigger_point:
              currentPageType === PageType.Article ? "article masthead upgrade button" : "masthead",
          },
          subcategory: "entry_point",
        });
        globalThis.location.href = `${config.accounts.host}/manage/subscription?upgrade=true`;
        window.postMessage({ type: "PIANO_UPGRADE_POPUP" }, "*");
      }}
      ref={captureTrackImpressionEventTargetElement}
    >
      Upgrade & Save
    </SubscriptionButton>
  );
};

UpgradeButton.displayName = "UpgradeButton";
